<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
    <el-dialog :visible.sync="spiderTest.popVisible"
               title="请输入需要访问的url"
               :before-close="cancelSpider">
      <el-form>
        <el-form-item style="white-space: pre-wrap;">
          <el-input type="textarea" :rows="20" v-model="spiderTest.spiderMsg"></el-input>
        </el-form-item>
      </el-form>
      <div class="spiderFlexCenter">
        <el-button type="primary" @click="saveSpider">{{ $t('im.bt.definite') }}</el-button>
        <el-button @click="cancelSpider">{{ $t('im.bt.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//table封装组件
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import URL from '@/views/cms/util/url'
import UPDATE from '@/components/page/update.vue'
import Qs from 'qs'
import axios from 'axios'
import DateUtil from "@/utils/IM/tradeDataUtil";

let langOptionList = {}, companysList = {}
let typeList = {
  0: '文章',
  1: '快讯',
  2: '财经日历'
}
let newsTypeList = []
let newsData = {}
let apiList = { 0: '否', 1: '是' }
let productList = {}
export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE
  },
  computed:{

  },
  created() {
    this.initProductType()
    this.initCascader()
    this.initLangs()
    this.initCompanys()
  },
  methods: {
    checkbox(row) {
      this.deleteIds = row.map(key => key.id).join(',')
    },
    /*表格按钮点击事件*/
    bthClick(clickName, row) {
      if (clickName == 'update') {
        let arr = JSON.parse(JSON.stringify(row))
        arr.typeIds = row.typeIds.split(',')
        this.$refs.childUpdate.open(arr)
      } else if (clickName == 'testSpider') {
        this.spiderTest.popVisible = true
        this.spiderTest.id = row.id
        this.spiderTest.spiderMsg="";
      } else if (clickName == 'delete') {
        this.dataChange(URL.spider.del + '/' + row.id, { id: row.id }, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultGetData(this.queryData)
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if ('查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      } else if ('新增' == clickName) {
        this.$refs.childUpdate.open()
      }
    },
    /*新增或跟提交数据触发事件*/
    submit(model) {
      model.typeIds = model.typeIds.join(',')
      //根据是否包含id更新还是添加
      this.dataChange((model.id != undefined && model.id != null && model.id != '') ? URL.spider.edit : URL.spider.edit, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultGetData(this.queryData)
        }
      })
    },
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    initProductType() {
      this.$axios.post(URL.product.typeList, {}).then(res => {
        if (res.code == 0) {
          let data = res.result
          if (data && data.length > 0) {
            for (const i in data) {
              productList[data[i].id] = data[i].name
            }
          }
        }
      })
    },
    delNodes(nodes = []) {
      for (let item of nodes) {
        if (item.children.length <= 0) {
          delete item.children
        } else {
          this.delNodes(item.children)
        }
      }
      return nodes
    },
    addNodes(data) {
      for (let i in data) {
        newsData[data[i].value] = data[i].label
        if (data[i].children && data[i].children.length > 0) {
          this.addNodes(data[i].children)
        }
      }
      return newsData
    },
    initCascader() {
      this.$axios.post(URL.type.cascader, {}).then(res => {
        if (res.code == 0) {
          let data = JSON.parse(JSON.stringify(res.result))
          this.delNodes(data)
          this.updateData.cols.find(function(e) {
            return e.field == 'typeIds'
          }).optionList = data
          newsTypeList = data
          this.addNodes(data)
          this.$refs.childTable.defaultQueryData(this.queryData)
        }
      })
    },
    initLangs() {
      this.$axios.post(URL.lang.query, {}).then(res => {
        if (res.code == 0) {
          let data = res.result
          if (data && data.length > 0) {
            for (const i in data) {
              langOptionList[data[i].code] = data[i].displayName
            }
            this.updateData.cols.find(function(e) {
              return e.field == 'lang'
            }).data = data[0].code
          }
        }
      })
    },
    initCompanys() {
      this.$axios.post(URL.company.query, {}).then(res => {
        if (res.code == 0) {
          let data = res.result.list
          if (data && data.length > 0) {
            for (const i in data) {
              companysList[data[i].code] = data[i].name
            }
            this.updateData.cols.find(function(e) {
              return e.field == 'companyCode'
            }).data = data[0].code
          }
        }
      })
    },
    cancelSpider() {
      this.spiderTest.popVisible = false
      this.spiderTest.isTimeData.forEach((item) => {
        window.clearInterval(item)
      })
      this.spiderTest.isTimeData = []
      this.spiderTest.isTime = null
    },
    saveSpider() {
      let option = {
        id: this.spiderTest.id,
        isTest:true,
        msgId:Date.parse(new Date())
      }
      this.$axios.post(URL.spider.test+"/"+this.spiderTest.id, Qs.stringify(option)).then(res => {
      })
      this.spiderTest.isTime = window.setInterval(() => {
        this.initMsg(option.msgId)
      }, 3000);
      this.spiderTest.isTimeData.push(this.spiderTest.isTime)
    },
    initMsg(msdId) {
      let option = {
        msdId: msdId
      }
      this.$axios.post(URL.spider.msg+"/"+msdId, Qs.stringify(option)).then(res => {
        if (res.code == 0) {
          if (res.result !== null) this.spiderTest.spiderMsg = res.result
          if (!this.spiderTest.popVisible) {
            this.spiderTest.isTimeData.forEach((item) => {
              window.clearInterval(item)
            })
            this.spiderTest.isTimeData = []
            this.spiderTest.isTime = null
          }
        }
      })
    }
  },
  destroyed() {
    this.spiderTest.isTimeData.forEach((item) => {
      window.clearInterval(item)
    })
    this.spiderTest.isTimeData = []
    this.spiderTest.isTime = null
  },
  data() {
    return {
      deleteIds: '',
      queryData: {},
      /*新增或更新*/
      updateData: {
        cols: [
          { title: 'id', field: 'id', hidden: true },
          { title: '域名(需要填寫http(s))', field: 'domain' },
          { title: '網站名称', field: 'netName' },
          { title: '网站语言', field: 'lang', type: 3, optionList: langOptionList, data: '1' },
          { title: '抓取url', field: 'url' },
          { title: '爬取规则', field: 'rule', textType: 'textarea' },
          { title: '编码方式', field: 'charset', data: 'utf-8' },
          { title: '时间格式', field: 'timeFormat' },
          { title: '分類', field: 'type', type: 2, optionList: typeList, data: 0, isNumber: true },
          { title: '资讯类型', field: 'typeIds', type: 15, optionList: newsTypeList, required: true, data: [] },
          { title: '所屬公司', field: 'companyCode', type: 2, optionList: companysList, required: true, data: [] },
          { title: '是否为接口', field: 'isJk', type: 3, optionList: apiList, data: 0, isNumber: true },
          { title: '立即生效', field: 'status', type: 3, optionList: apiList, data: 0, isNumber: true },
          { title: '产品管理', field: 'productId', type: 2, optionList: productList, isNumber: true }
        ]
      },
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { click: '查询', auth: 'cms:spider:list' },
          { click: '新增', auth: 'cms:spider:save' }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: URL.spider.query, //请求路径和参数
        selection: true,
        sequence: false,
        cols: [
          { title: 'domain', field: 'domain' },
          {
            title: 'status', field: 'status', minWidth: 30, render: (data, full) => {
              return apiList[data]
            }
          },
          { title: 'timeFormat', field: 'timeFormat' },
          { title: 'execution_time', field: 'executionTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: 'effective_time', field: 'executionTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: 'result', field: 'result'},
          { title: 'netName', field: 'netName' },
          {
            title: 'type', field: 'type', minWidth: 50, render: (data, full) => {
              return typeList[data]
            }
          },
          {
            title: 'isJk', field: 'isJk', minWidth: 30, render: (data, full) => {
              return apiList[data]
            }
          },
          { title: 'charset', field: 'charset', minWidth: 30 },
          {
            title: 'lang', field: 'lang', minWidth: 30, render: (data, full) => {
              return langOptionList[data]
            }
          },
          {
            title: 'companyCode', field: 'companyCode', render: (data, full) => {
              return companysList[data]
            }
          },
          {
            title: 'typeIds', field: 'typeIds', render: (data, full) => {
              let arr = data.split(','), newData = []
              for (const i in arr) {
                newData.push(newsData[arr[i]])
              }
              return newData.join('/')
            }
          },
          {
            title: '操作',
            minWidth: 200,
            btnClick: [{
              name: '删除',
              click: 'delete',
              type: 'primary',
              icon: 'el-icon-delete',
              auth: 'cms:spider:del'
            }, { name: '修改', click: 'update', type: 'primary', icon: 'el-icon-edit', auth: 'cms:spider:edit' },
              { name: '測試爬取', click: 'testSpider', type: 'primary', icon: 'el-icon-edit', auth: 'cms:spider:test' }]
          }

        ]
      },
      /*爬取测试*/
      spiderTest: {
        popVisible: false,
        isTime: null,
        isTimeData:[],
        msdId: '',
        spiderMsg: ''
      }
    }
  },
}
</script>
<style>
.spiderFlexCenter {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
</style>
